export default __webpack_public_path__ + "static/media/bet5.a1c2d9bf.png";